import star from '../assets/star.svg'


export default function Stars({ no }) {

  const ary = []
  const handlen = (no) => {
    no = Math.round(no)
    for (let i = 0; i < no; i++) {
      ary.push(1)
      // console.log(i)
    }
  }

  return (
    <>
      {/* <h1>Stars  {no}</h1> */}
      {handlen(no)}
      {ary.map((a,i) =>
        <img
          key={i}
          src={star}
          alt=""
        />
      )}
    </>
  )
}
